const transformKeywords = (keywords = '') => keywords
  .split(/\s*,\s*/).filter((keyword) => keyword);

export default transformKeywords;
